import { NgModule } from '@angular/core';
import { HttpModule } from '@angular/http';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { FormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { AppComponent } from './app.component';
import { AppRouteModule } from './app.routing.module';
import { AdminModule } from './admin/admin.module';

import { FrontModule } from './front/front.module';
import { AuthModule } from './auth/auth.module';
import { SharedModule } from './shared/shared.module';

import { APP_CONFIG, AppConfig } from './app.config';
import { LoadingModule } from 'ngx-loading';
import { MyDesktopService } from './services/mydesktop.service';
import { AuthService } from './services/auth.service';
import { CookieService } from 'ng2-cookies';
import { AuthGuard } from './services/auth-guard.service';
import { AuthBlockGuard } from './services/auth-block-guard.service';
import { AuthAdminGuard } from './services/auth-admin-guard.service';
import { OptionService } from './services/option.service';
import { MaintenanceGuard } from './services/maintenance-guard.service';
import { FileDropModule } from 'ngx-file-drop/lib/ngx-drop';

import { AuthInterceptor } from './shared/auth.interceptor';
import { ParticaService } from './services/partica.service';
import { VaultService } from './services/vault.service';
import { CampaignService } from './services/campaign.service';
import { GlobalService } from './services/global.service';
import { DomainService } from './services/domain.service';

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    BrowserModule,
    HttpClientModule,
    HttpModule,
    FormsModule,
    SharedModule,
    AdminModule,
    FrontModule,
    AppRouteModule,
    AuthModule,
    BrowserAnimationsModule,
    LoadingModule,
    FileDropModule
  ],
  providers: [
    GlobalService,
    MyDesktopService,
    AuthService,
    AuthGuard,
    AuthBlockGuard,
    AuthAdminGuard,
    CookieService,
    OptionService,
    MaintenanceGuard,
    ParticaService,
    VaultService,
    DomainService,
    CampaignService,
    {provide: APP_CONFIG, useValue: AppConfig},
    {provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true}
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts